/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactMaterialFromJSON, ContactMaterialToJSON } from './ContactMaterial';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetContactMaterialsResponseDataFromJSON(json) {
    return GetContactMaterialsResponseDataFromJSONTyped(json, false);
}
export function GetContactMaterialsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactMaterials: !exists(json, 'contact_materials')
            ? undefined
            : json['contact_materials'].map(ContactMaterialFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetContactMaterialsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_materials: value.contactMaterials === undefined
            ? undefined
            : value.contactMaterials.map(ContactMaterialToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
